import DTM from 'shared/helpers/DTM';

const EVENTS = {
  ADD_TO_HOME_SCREEN_ACCEPTED: 'add-to-home-screen-accepted',
  ADD_TO_HOME_SCREEN_DECLINED: 'add-to-home-screen-declined',
  ADD_TO_HOME_SCREEN_BANNER_OPENED: 'add-to-home-screen-banner-open',
};

export const trackAddToHomeScreenAccepted = () => DTM.track(EVENTS.ADD_TO_HOME_SCREEN_ACCEPTED);

export const trackAddToHomeScreenDeclined = () => DTM.track(EVENTS.ADD_TO_HOME_SCREEN_DECLINED);

export const trackBannerOpened = (via: string) =>
  DTM.track(EVENTS.ADD_TO_HOME_SCREEN_BANNER_OPENED, { a2hs_banner_referer: via });
